import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Form } from "reactstrap";
import { ApplicantActions } from "../../actions";
import recSvg from "../../resources/images/recuriter.svg"
import downArraow from '../../assets/images/down-arrow.svg'
import { useEffect, useState } from "react";

const StatusForm = (props) => {
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState('');
  const [selectOptions, setSelectOptions] = useState([]);
  const getAppliocantStatus = useSelector((state) => state.applicant.applicantStatus)

  const onChange = (e) => {
    ChangeStatus(e.target.value);
    setSelectedItem(e.target.value);
  };

  const ChangeStatus = (applicationStatus) => {
    if (props?.row?.id) {
      dispatch(ApplicantActions.updateApplicant({ applicationStatus: applicationStatus }, props?.row?.id));
    }
  }

  useEffect(() => {
    setSelectedItem(props?.row?.applicationStatus)
  }, [props])

  useEffect(() => {
    setSelectOptions(getAppliocantStatus);
  }, [getAppliocantStatus])

  const checkIsSelected = (value) => {
    return value == selectedItem ? true : false
  }

  return (
    <>
      <Form>  
        <div className="form-group">
          <img src={recSvg} className="statusImage" alt="Status" />
          <span className="statusLabel">Status</span>
          <select
            name="applicationStatus"
            id="applicationStatus"
            onChange={onChange}
            className="commen-select form-control"
            value={selectedItem}
          >
            {selectOptions && selectOptions.length > 0 ?
              selectOptions.map((val) => (
                <option
                  value={val?.status}
                  selected={checkIsSelected(val?.status)}
                >
                  {val?.status}
                </option>
              )) : ""
            }
          </select>
        <img className="down-arrow-image" src={downArraow} alt="downArrow" />
        </div>
      </Form>
    </>
  );
};

export default StatusForm;
